<template>
  <div class="page-container user-phoneNumber">
    <div class="header">
      <span>
                <i style="margin-right: 10px;">电话</i>
            </span>
      <div class="phone-button">
      </div>
    </div>
    <div v-if="showAudio" class="audio-container">
      <i @click="showAudio = false" class="el-icon el-icon-close close"></i>
      <vue-audio-player :isRecordingSplit="patientData.isRecordingSplit" v-if="audio && !isCalling"
                        :splitPoint="splitPoint" ref="audio" :src="audio"></vue-audio-player>
    </div>
    <div class="user-list">
      <!-- 发送短信 -->
      <template v-if="isModel === 'beMessage'">
        <div v-loading="item.showLoading" class="phoneList" v-for="(item,index) in patientList" :key="index"
             :class="{'lastCall':currentCallNumber === item.phoneNumber}"
             :style="(showGray&&item.phoneLabel!=='仅随访该号码')?'background:rgba(0,0,0,.1);':'background:#fff;'">
          <div class="user_tel_box">
            <div class="user_tel_base">
              <span v-if="item.relationshipLevel"
                    style="display:inline-block;min-width: 15px;color: #248cfa;font-size: 12px;text-align: center; border: 1px solid #248cfa;border-radius: 50px;width: 20px;height: 20px;line-height: 20px">{{ item.relationshipLevel }}</span>
              <span v-else style="display: inline-block;width: 20px;"></span>
              <span class="min15">

                <span v-text="`${item.phoneNumberStar}`" class="phone-number"
                      @click="manualCall(item.phoneNumber,item.id,item)"
                ></span>
                <span >{{ item.contactName }}</span>
              </span>
              <span class="phone-number min15" v-show="item.lastCallState"
                    style="margin-left: 8px;color: #666;">状态：-{{ getCodeName(item.lastCallState) }}</span>
              <span class="min15">关系：{{item.relationshipName}}</span>
            </div>
            <div class="user-tel-state">

                <span class="icon-span" @click="callHistoryClickHandler(item)"
                      title="查看通话记录">
                                      <img src="./img/history.png" alt="">
                                </span>

            </div>

          </div>
          <div v-if="item.showAudio" class="audio-list">
            <div class="audio-list-item" v-for="(it,ind) in item.phoneRecordInfoList">
              <div><span
                  style="margin-right: 15px;display: inline-block;min-width: 100px">{{
                  getCodeName(it.callState)
                }}</span>
                {{ it.createTime }}
                <span style="margin-left: 25px;">{{ it.seatName }}</span>
              </div>
              <div>
                <el-button v-if="it.isRecording || it.recording" @click="getAudio(it.contactId,it.splitPoint,it.id)"
                           size="mini" type="text">听录音
                </el-button>
                <el-button
                    :style="{color: new Date().getTime() - new Date(it.createTime).getTime() < 40000 ? '#e57979' : '#d8d8d8'}"
                    v-else @click="refreshAudioList(item)"
                    :disabled="new Date().getTime() - new Date(it.createTime).getTime() > 40000" size="mini"
                    type="text">
                  {{
                    new Date().getTime() - new Date(it.createTime).getTime() < 40000 ? '暂无录音（点击刷新）' : '暂无录音'
                  }}
                </el-button>
              </div>
            </div>
          </div>
        </div>
      </template>
      <template v-else-if="isModel === 'messageing'">
        <el-checkbox-group v-model="checkPhoneList" @change="handleChangeUser" class="message-list">
          <el-checkbox v-for="(item,index) in patientList" :label="item.id" :key="index"
                       :disabled="item.isBeenSend">
            <p class="users">
              <span v-text="`${item.relationshipName}`"></span>
              <span v-text="`(${item.phoneNumberStar})`"></span>
            </p>
          </el-checkbox>
        </el-checkbox-group>
      </template>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
import _ from 'lodash'
import {
  RestNewFollowupCallCenterServiceGetPhoneRecordInfoListByPhoneNumber,
  RestFeedbackOutControllerUpdateRecordList,
  RestNewFollowupCallCenterServiceAddFollowupPatientContactInformation, // 添加患者手机号码
  RestNewFollowupCallCenterServiceUpdateFollowupPatientContactInformation, // 更新患者手机号码
  // RestCallCenterServiceGetPatientPhoneNumberList , // 获取患者电话列表
  RestNewFollowupCallCenterServiceSendingFollowupSms, // 发送短信
  RestNewFollowupCallCenterServiceSendingFollowupSmsTask,//发送短信
  RestNewFollowupCallCenterServiceGetSmsTemplateByCode,//获取短信模板详情
  RestCallCenterServiceGetAllRelationship,  // 获取关系列表
  RestNewFollowupCallCenterServiceUpdatePhoneNumberCallState, //添加本次呼叫状态(是否已失访)
  RestNewFollowupCallCenterServiceUpdateLaterCallFollowupTask,// 稍后拨叫
  RestNewFollowupCallCenterServiceGetDiseaseSmsTemplateList, //获取疾病对于短信列表
  RestNewFollowupCallCenterServiceFirstUpdatePhoneNumberCallState, //第一次保存呼叫记录
  RestFeedbackOutControllerGetRecordList,
  RestNewFollowupCallCenterServiceGetALiRecording,
  RestNewFollowupCallCenterServiceGetSmsTemplateTaskList,
  RestNewFollowupCallCenterServiceAddRecordWaitingTime,//通话时间
  RestNewFollowupCallCenterServiceGetCallLaterFollowupTaskPatientInfoList, //获取抽查列表
  RestNewFollowupCallCenterServiceGetAbnormalFollowupTaskPatientInfoList,
  RestNewFollowupCallCenterServiceGetFollowupPatientContactInformationList,
  RestNewFollowupCallCenterServiceGetPhoneLabelList,//获取手机号标签
  RestNewFollowupCallCenterServiceAddOrSelectPhoneLabel, //添加或选择手机号标签
} from "@src/assets/js/api.js";
import errorHandleMixin from '@mixins/errorHandleMixin';
import {mapState, mapGetters, mapMutations} from 'vuex'
import vueAudioPlayer from '../AudioPlayer/vueAplayerN'
import {RestNewFollowupCallCenterServiceGetAllRelationshipLevel} from "../../assets/js/api";

export default {
  name: 'UserPhone',
  data() {
    return {
      splitPoint: null,
      connectList: [],
      connectListAll: [],
      callingNumber: null,
      audioLoading: false,
      callStatus: '正在拨号',
      hangState: true, //能不能挂断
      smsDetail: '',
      messageTarget: {
        phoneNumberStar: ''
      },
      messageDialogVisible: false,
      statusError: false,
      showAudio: false,
      audio: '',
      timer: null,
      callReturnId: null,
      currentContactId: null,
      recordId: null,
      isCallHold: true,
      intervalTimer: null,
      seconding: 0,
      status: "work",
      followupModeChecked: false,
      smsList: [], //短信列表
      smsSelect: null,
      answerType: 1,
      isCalling: false, //当前是否为 打电话
      callStatusVisible: false, // 播放
      callRecordListVisible: false,
      multipleSelection: [],
      callRecordList: [],//呼叫记录列表
      phoneList: [{
        relationshipName: '本人',
        phoneNumber: '12312312312',
        status: '拨号中',
        id: "1"
      }, {
        relationshipName: '老婆',
        phoneNumber: '1231312313',
        status: '挂断',
        id: "2"
      }],
      unconvertPhone: [],
      // 无效
      phoneModel: {
        phoneNumber: '',
        relationshipId: ''
      },
      pickerOptions: {
        shortcuts: [
          {
            text: '明天',
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() + 3600 * 1000 * 24);
              picker.$emit('pick', date)
            }
          },
          {
            text: '后天',
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() + 3600 * 1000 * 24 * 2);
              picker.$emit('pick', date)
            }
          },
          {
            text: '一周之后',
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() + 3600 * 1000 * 24 * 7);
              picker.$emit('pick', date)
            }
          }
        ],
        disabledDate(time) {
          return time.getTime() < Date.now() - 24 * 3600 * 1000;
        },
      },
      // form -- 电话
      form: {
        contactName: "",
        phoneNumber: "",
        relationshipLevel: "",
        relationshipLevelId: "",
        lastCallState: ""
      },
      // form -- 稍后拨打
      nextTimeForm: {
        nextCallTime: ''
      },
      editDialogVisible: false,
      // 再次拨打 dialog
      callNextTimeVisible: false,
      isShowNextTimeClose: false, // show-close
      isCloseEscape: false, // close-on-press-escape
      closeModal: false, // close-on-click-modal
      showPhoneAdd: false, // 是否显示添加
      dialogType: 'add',
      // dialog --- phone
      phoneDialogVisible: false,
      hangupDisabled: true,
      // 发送短信模式
      isModel: 'beMessage', //  beMessage 即将发送短信模式  messageing
      checkPhoneList: [],
      // validator
      validatorRule: {
        relationshipName: [
          {required: false, message: '请选择关系', trigger: 'trigger'}
        ],
        contactName: [
          {required: false, message: '请输入姓名', trigger: 'trigger'}
        ],
        phoneType: [
          {required: true, message: '请选择联系方式', trigger: 'trigger'}
        ],
        phoneNumber: [
          {required: true, message: '请填写手机号', trigger: 'blur'},
        ]
      },
      nextTimeFormRule: {
        nextCallTime: [
          {required: true, message: '请填写日期', trigger: 'trigger'},
          {validator: this.nextTimeValidator, trigger: 'trigger'}
        ],
      },
      // 当前 患者信息
      currentRelationPatientInfo: null,
      relationShipList: [], // 关系列表
      patientList: [], // 患者列表
      phoneCallStateList: [
        {code: 1, codeName: '稍后拨打'},
        {code: 2, codeName: '仅随访该号码'},
        {code: 3, codeName: '短信随访成功'},
        {code: 4, codeName: '电话随访成功'},
        {code: 5, codeName: '初始化'},
        {code: 6, codeName: '挂断（接通）'},
        {code: 7, codeName: '无人接听'},
        {code: 8, codeName: '挂断（未接通）'},
        {code: 9, codeName: '停机'},
        {code: 10, codeName: '关机'},
        {code: 11, codeName: '拒随'},
        {code: 12, codeName: '空号'},
        {code: 13, codeName: '错号'},
        {code: 14, codeName: '不知情'},
        {code: 15, codeName: '沟通不畅'}], // 电话状态列表
      radioCheck: null,
      showCheck: {
        check1: false,
        check2: false,
        check3: false,
      },
      customLabel: "",
      selectPhoneLabelId: null,
      categoryPopoverVisible: false,
      callSuccess: false,//是否接通
      testItem: {},
      showGray: false,
      phoneLabelList: [],
      calleePhoneNumber: 'auto',
      concatIDBackUp: "",
      addContactInfo: [{
        phoneType: true,
        phoneNumber: null,
        contactName: null,
        relationshipLevel: null,
        relationshipName: null,
        cooperateScore: null,
        code: null,
      }],
      cutTimeInterVal: null,
      cutTime: 0,
      cutTimeTemp: 0,
      patientListItem: {},
      relationshipLevelList: [],
      smsSendRecordLists: [], //短信发送记录
    }
  },
  computed: {
    workBenchCallStatusText() {
      let result = ""
      switch (this.workBenchCallStatus) {
        case 3:
          result = '空闲[可外呼]';
          break
        case 2:
          result = '小休';
          break
        case 1:
          result = '离线[需登录]';
          break
        case 5:
          result = '通话后处理';
          break
        case 8:
          result = '拨号[可挂断]';
          break
        case 10:
          result = '呼出通话[可挂断]';
          break
        case -1:
          result = '未注册';
          break
        case 0:
          result = '注册中';
          break
      }
      return result
    },
    ...mapGetters([
      'patientId',
      'userid',
      'username',
      'phoneStatus',
      'getTaskCenterId',
      "getCallingNumber"
    ]),
    ...mapState([
      'taskId',
      'nextCallNumber',
      'workBenchCallStatus',
      'currentCallNumber',
      'currentCallNumberId',
      'contactId',
      'nextCallNumberId',
      "callObj"
    ]),
    // 新增
    operator() {
      return this.dialogType === 'add' ? '新增联系人' : '编辑联系人'
    },
    uniqueId() {
      return _.uniqueId('relation_')
    },
    taskType() {
      return this.$route.query.taskType && parseInt(this.$route.query.taskType, 10) || ''
    },
    isAbnormal() {
      return this.$route.query.abnormal === 2; //1是正常 2是异常
    }

  },
  created() {
    // 获取 关系列表
    this.getReationShip();
  },
  watch: {
    patientList: {
      handler(val, oldVal) {
        if (val != oldVal) {
          this.followupModeChecked = false
          let temp = val.filter(item => {
            return item.phoneLabel == "仅随访该号码"
          })
          if (temp.length > 0) {
            this.showGray = true
          } else {
            this.showGray = false
          }
        }
      },
      deep: true,
      immediate: true
    },

  },
  components: {vueAudioPlayer},
  mounted() {
    let vm = this;
    // console.log('CODE', window.workbench.getStatusCode().code);
    this.getPhoneNumber()
        .then(res => {
          console.log(res);
          this.calleePhoneNumber = res.retValue == '未查到对应任务坐席信息' ? 'auto' : res.retValue
        })
    vm.getAllRelationshipLevel()
        .then(res => {
          this.connectListAll = res.retValue.filter(item => item.relationship != '其他')
          this.connectListAll.push({
            id: null,
            level: 3,
            relationship: '其他'
          })
          this.connectList[0] = res.retValue.filter(it => it.level == 1)
          this.connectList[1] = res.retValue.filter(it => it.level == 2)
          this.connectList[2] = res.retValue.filter(it => it.level == 3)
        })
    vm.followupModeChecked = false
    let temp = vm.patientList.filter(item => {
      return item.phoneLabel == "仅随访该号码"
    })
    if (temp.length > 0) {
      this.showGray = true
    } else {
      this.showGray = false
    }
  },
  props: {
    patientData: {
      type: Object,
      default() {
        return {}
      }
    },
    // isAbnormal:{
    //     type:Boolean,
    // },
  },
  mixins: [errorHandleMixin],
  methods: {
    ...mapMutations(['setNextCallNumber', 'removeContactId', 'removeContactIds', 'setCurrentCallNumber', 'setCurrentCalling', 'setContactSuccessIds', 'setContactId']),
    updateTimer(startTime) {
      let currentTime = new Date().getTime(); // 获取当前时间的毫秒数
      let elapsedTime = currentTime - startTime; // 计算经过的时间（毫秒）

      // 将毫秒转换为秒和毫秒部分
      let seconds = Math.floor(elapsedTime / 1000);
      let milliseconds = elapsedTime % 1000;
      this.cutTime = `${seconds}.${milliseconds}`
      // console.log(`经过了 ${seconds} 秒 ${milliseconds} 毫秒`);
    },
    cutTimeHandler() {
      this.cutTimeTemp = this.cutTime
      this.splitPointHandler(true, this.cutTime)
    },
    async cancellationRecordingSplit() {
      let result = await this.$store.dispatch('requestHandler', {
        fn: 'RestNewFollowupCallCenterServiceCancellationRecordingSplitPoint',
        params: {
          id: this.callReturnId,
          nowUserId: this.userid,
          followUpTaskId: this.getTaskCenterId,
          followupPatientInfoId: this.patientData.followupPatientId,//后端参数取得followupPatientId 忽略传参参数
          phoneNumber: this.currentRelationPatientInfo.phoneNumber
        }
      })
    },
    async splitPointHandler(isDelay, second) {
      let result = await this.$store.dispatch('requestHandler', {
        fn: 'RestNewFollowupCallCenterServiceUpdateRecordingSplitPoint',
        params: {
          id: this.callReturnId,
          recordingSplitPoint: second || this.cutTime,
          isDelay: isDelay || false,
          nowUserId: this.userid,
          followUpTaskId: this.getTaskCenterId,
          followupPatientInfoId: this.patientData.followupPatientId,//后端参数取得followupPatientId 忽略传参参数
          phoneNumber: this.currentRelationPatientInfo.phoneNumber
        }
      })
    },
    changeHandlerconnectAdd(contact) {
      let list_item = this.connectListAll.find(item => item.relationship == contact.relationshipName)
      contact.relationshipLevel = list_item ? list_item.level : null
      if (list_item) {
        this.relationshipLevelList = [
          {value: 1, label: '一级联系人'},
          {value: 2, label: '二级联系人'},
          {value: 3, label: '三级联系人'},
        ]
      } else {
        this.relationshipLevelList = []
      }
    },
    changeHandlerconnectEdit(contact, type) {
      let list_item = this.connectListAll.find(item => item.relationship == contact.relationshipName)
      contact.relationshipLevel = list_item ? list_item.level : null
      contact.relationshipLevelId = list_item ? list_item.id : null
      if (list_item) {
        this.relationshipLevelList = [
          {value: 1, label: '一级联系人'},
          {value: 2, label: '二级联系人'},
          {value: 3, label: '三级联系人'},
        ]
      } else {
        this.relationshipLevelList = []
      }
      if (type == 2) {// 联系人列表里直接保存编辑
        this.confirmEditHandler(contact)
      }
    },
    rebackVideoAuto() {
      setTimeout(() => {
        this.showLastPhoneList()
            .then(() => {
              let lastCallUser = this.patientList.find(item => item.isLast)
              console.log(lastCallUser);
              let lastReocrd = lastCallUser.phoneRecordInfoList.find(item => item.isRecording)
              let concatId = lastReocrd.contactId
              let splitPoint = lastReocrd.splitPoint
              let id = lastReocrd.id
              console.log(concatId);
              if (concatId) {
                this.getAudio(concatId, splitPoint, id)
              }
            })
      }, 4000)
    },
    //获取外呼号码
    async getPhoneNumber() {
      let result = await this.$store.dispatch('requestHandler', {
        fn: 'RestCallCenterServiceGetPhoneNumber',
        params: {
          taskId: this.getTaskCenterId,
          seatId: this.userid
        }
      })
      return result
    },
    showLastPhoneList() {
      return new Promise(resolve => {
        let lastCallUser = this.patientList.find(item => item.isLast)
        this.callHistoryClickHandler(lastCallUser)
            .then(() => {
              resolve()
            })
      })
    },
    getAudio(concatId, splitPoint, id) {
      this.callReturnId = id || null
      this.currentContactId = concatId || null
      this.audio = ''
      this.getRecordList(concatId)
          .then(res => {
            if (res.retValue[0]) {
              this.showAudio = true
              this.audio = JSON.parse(res.retValue[0])
              this.splitPoint = splitPoint || null
              setTimeout(() => {
                this.$refs.audio.startPlayOrPause()
              }, 1000)
              this.$forceUpdate()
            } else {
              this.showAudio = false
              this.$message.error('暂无录音')
            }
          })
    },
    relationCallStatechangeHandler(item, type) {
      this.currentRelationPatientInfo = item
      this.updateUserPhone(type)
    },
    refreshAudioList(item) {
      this.getFollowupPatientRecordList(item)
    },
    callHistoryClickHandler(item) {

      return new Promise(resolve => {
        if (!item.showAudio) {
          this.currentRelationPatientInfo = item
          this.getFollowupPatientRecordList(item)
              .then(() => {
                if (item.phoneRecordInfoList && item.phoneRecordInfoList.length) {
                  this.$delete(item, 'showAudio')
                  this.$set(item, 'showAudio', true)
                  // item.showAudio = !item.showAudio
                } else {
                  this.$message.error('暂无记录')
                }

                resolve()
              })
        } else {
          console.log(111);
          this.$delete(item, 'showAudio')
          this.$set(item, 'showAudio', false)
          resolve()
        }
      })


    },
    async getRecordList(concatId) {
      let request = new RestNewFollowupCallCenterServiceGetALiRecording()
      request.p_contactId = concatId
      await request.send()
      return request.result
    },
    //===========================calling==============
    secondText() {
      let value = this.seconding;
      var theTime = parseInt(value); // 秒
      var middle = 0; // 分
      var hour = 0; // 小时

      if (theTime >= 60) {
        middle = parseInt(theTime / 60);
        theTime = parseInt(theTime % 60);
        if (middle >= 60) {
          hour = parseInt(middle / 60);
          middle = parseInt(middle % 60);
        }
      }
      var result =
          parseInt(theTime) < 10
              ? "0" + parseInt(theTime)
              : "" + parseInt(theTime);
      var middleText =
          parseInt(middle) < 10 ? "0" + parseInt(middle) : "" + parseInt(middle);
      result = middleText + ":" + result;
      if (hour > 0) {
        result = parseInt(hour) + ":" + result;
      }
      return result;
    },
    // 获取当前的拨叫状态
    getCurrentCode() {
      console.log('getStatus', window.workbench && window.workbench.getStatusCode() && window.workbench.getStatusCode().code);
      return window.workbench && window.workbench.getStatusCode() && window.workbench.getStatusCode().code || null
    },
    calling() {
      if (window.workbench) {
        console.log('status', this.status);
        if (this.status === "work") {
          // call(callee, caller, publicKey, useVirNumCall)
          // callee为被叫号码不可空，必传，加密时传加密后的密文，不加密时传真实被叫号码。
          // caller为主叫号码，可以指定主叫号码，不使用加密时可以不传，或者传‘auto’。不传时使用面板里选择的主叫号码或技能组所绑定外呼号码的第一个,为‘auto’时，根据外呼的号码的归属地选择与与其同一归属地的主叫号码，若没有同一归属地的就随机在技能组里选择一个主叫号码。使用加密时必传。
          // publicKey为公钥，对被叫号码进行加initAliyunCall密时该值必传，非加密情况不传或传空值。使用加密方式外呼时,需要调用加密接口 [Encrypt ](https://help.aliyun.com/document_detail/75726.html) 将号码进行加密，得到加密后的被叫号码和公钥后直接调用该call方法：call('密文', '主叫号码', '公钥' )。
          // useVirNumCall为Boolean类型，传true表示只要caller配置了虚拟号码都会使用虚拟号码进行外呼，不传或传false,如果您使用呼叫中心的面板进行操作，会根据坐席是否选择使用外呼号码进行呼叫，如果勾选了则将使用虚拟号码进行外呼否则直接用呼叫中心的号码进行呼叫。
          console.log('calling  -------------- ', this.nextCallNumber)
          this.beforeCall()
              .then((res) => {
                if (res) {
                  if (this.nextCallNumber) {
                    window.workbench.call(this.nextCallNumber, this.calleePhoneNumber, null, false); // TODO
                    this.setCurrentCallNumber({
                      currentCallNumber: this.nextCallNumber,
                      currentCallNumberId: this.nextCallNumberId
                    })
                    this.setCurrentCalling(true)
                    this.setCallingStatus();
                    window.pubsub && window.pubsub.emit('calling');
                  } else {
                    this.errorHandle({
                      message: '该患者无可拨打的电话'
                    })
                  }
                } else {
                  this.$message.error('缺少contractId')
                }
              })

          // // for 测试
          // window.workbench.call("15708497684", "auto", null, false); // TODO
          // this.setCurrentCallNumber({currentCallNumber:this.nextCallNumber ,currentCallNumberId : this.nextCallNumberId})
          // this.setCallingStatus();
          // window.pubsub&&window.pubsub.emit('calling');
        } else {
          this.errorHandle({
            message: "请先重新回到工作中。。。"
          });
        }
      } else {
        this.errorHandle({
          message: "云呼叫中心无法连接，请退出重新登录"
        });
      }
    },
    listenHangUp() {
      console.log('listenHangUp');
      this.setCallHangUpStatusDialog()
      // this.setCurrentCalling(false)
      this.setHangUpStatus();
      // window.pubsub && window.pubsub.emit('callHangUp');
      // clearInterval(this.timer)
      clearInterval(this.intervalTimer)
      this.setCallTime()
      this.hangState = false //已挂断0
    },
    //点击挂断的操作
    hangUp() {
      console.log('hangUp');
      if (window.workbench) {
        console.log(window.workbench.getStatusCode().code);
        // this.$message.info('提示请忽略：当前状态 ' + window.workbench.getStatusCode().code)
        if (window.workbench.getStatusCode().code == -1) {
          this.$message.error('当前状态不能挂断电话')
        }
        // 挂断
        window.workbench.hangUp();
        // this.setCallHangUpStatusDialog()
        // this.setCurrentCalling(false)
        // this.setHangUpStatus();
        window.pubsub && window.pubsub.emit('callHangUp');
        // 如果是 这个页面
        // clearInterval(this.timer)
      } else {
        this.errorHandle({
          message: "云呼叫中心无法连接，请退出重新登录"
        });
      }
      // this.setCallTime()
    },
    // 电话保持
    callHold() {
      if (window.workbench) {
        if (this.getCurrentCode() == 10 || this.getCurrentCode() == 9) {
          window.workbench.callHold();
          this.isCallHold = false;
        } else {
          this.$message({
            type: "warning",
            message: "您好，此时您的状态不能进行通话保持"
          });
        }

      } else {
        this.errorHandle({
          message: "云呼叫中心无法连接，请退出重新登录"
        });
      }
    },
    // 电话取回
    callRetrieve() {
      // 12
      if (window.workbench) {
        // 挂断
        window.workbench.callRetrieve();
        this.isCallHold = true;
      } else {
        this.errorHandle({
          message: "云呼叫中心无法连接，请退出重新登录"
        });
      }
    },
    // 挂断后的状态
    setHangUpStatus() {
      this.intervalTimer && clearInterval(this.intervalTimer);
      // this.seconding = 0;
      this.isCalling = false;
    },
    // 拨打的状态
    setCallingStatus() {
      this.isCalling = true;
      this.intervalTimer = setInterval(() => {
        this.seconding++;
      }, 1000);
    },
    // ================== validator ===================
    phoneValidator(rule, value, callback) {
      if (/^1[34578]\d{9}$/.test(value)) {
        callback()
      } else {
        callback('手机号码不符合规范')
      }
    },
    nextTimeValidator(rule, value, callback) {
      console.log(rule, value, callback)
      if (value) {
        let selectTime = new Date(value).getTime()
        let now = new Date().getTime();
        if (selectTime < now) {
          callback('选择的时间必须为未来时间')
        } else {
          callback()
        }
      } else {
        callback()
      }
    },
    //获取短信列表
    getSmsList() {
      this.asyncGetSmsList()
          .then(res => {
            console.log(res);
            if (res.status == 0) {
              this.smsList = res.retValue
            } else {
              this.$message.error(res.desc)
            }
          })
    },
    checkHasLastCallUser() {
      return new Promise(resolve => {
        let lastCallUser = this.patientList.find(item => item.isLast)
        if (!lastCallUser) {
          resolve(false)
        } else {
          resolve(lastCallUser.lastCallState)
        }
      })
    },
    //操作前的判断 最近拨叫是初始化就需要报错
    checkSubmitStatus(callnum) {
      console.log(1111);
      return new Promise(resolve => {
        let lastCallUser = this.patientList.find(item => item.isLast)
        console.log(lastCallUser);
        if (!lastCallUser) {
          this.statusError = false
          resolve(true)
        } else {
          // if(callnum && callnum == lastCallUser.phoneNumber) {
          //     resolve(true)
          //     this.statusError = false
          // }
          if (lastCallUser.lastCallState == 5) {
            this.statusError = true
            this.$message.error('请选择呼叫状态')
            resolve(false)
          } else {
            this.statusError = false
            resolve(true)
          }
        }
      })
    },
    // ========================= 联系人的保存 =========================
    // 编辑按钮事件
    // editRelation(item) {
    //   this.phoneDialogVisible = true;
    //   this.dialogType = 'edit';
    //   this.currentRelationPatientInfo = item;
    //   this.$nextTick(() => {
    //     // this.$refs['validatorForm'].resetFields();
    //     this.form = {
    //       phoneNumber: item.phoneNumberStar,
    //       relationshipName: item.relationshipName ? item.relationshipName : "",
    //       lastCallState: item.lastCallState ? item.lastCallState : ""
    //     }
    //   })
    // },
    // 新增按钮事件
    addHandle() {
      // 如果是发送 短信页面 ,切换状态
      if (this.isModel === 'messageing') {
        this.toggleUserMode()
      }
      this.phoneDialogVisible = true;
      this.dialogType = 'add';
      this.$nextTick(() => {
        // this.$refs['validatorForm'].resetFields();
        // this.form = {
        //   ...{
        //     phoneNumber: '',
        //     relationshipLevel: '',
        //     relationshipLevelId: ''
        //   }
        // }
        this.addContactInfo = [{
          phoneType: true,
          phoneNumber: null,
          contactName: null,
          relationshipLevel: null,
          relationshipLevelId: null,
          relationshipName: null,
          cooperateScore: null,
          code: null,
        }]
      })
    },
    // 取消 dialog
    addContactHandle() {
      let _data = {
        phoneType: true,
        phoneNumber: null,
        contactName: null,
        relationshipLevel: null,
        relationshipLevelId: null,
        relationshipName: null,
        cooperateScore: null,
      }
      this.addContactInfo.push(_data)
    },
    deleteContactHandle(index) {
      this.addContactInfo.splice(index, 1)
    },
    changeInput() {
      this.$forceUpdate() //强制刷新
    },
    //  保存 dialog---hmz
    phoneTypeChange(contact) {
      contact.code = null
      contact.phoneNumber = null
    },
    saveHandle() {
      let filter_list = this.addContactInfo.filter(item => {
        if (item.phoneType == null) {
          return item
        } else if (item.phoneType && !item.phoneNumber) {
          return item
        } else if (item.phoneType === false && (!item.code || !item.phoneNumber)) {
          return item
        }
      })
      if (filter_list.length > 0) {
        this.$message.warning("请检查联系方式和号码是否填写完整")
        return
      }
      let _list = this.addContactInfo.map(item => {
        let temp = {
          phoneNumber: item.code ? `${item.code}-${item.phoneNumber}` : item.phoneNumber,
          relationshipName: item.relationshipName,
          contactName: item.contactName,
          phoneType: item.phoneType,
          relationshipLevel: item.relationshipLevel,
          cooperateScore: item.cooperateScore,
        }
        return temp
      })
      // console.log('保存', _list);
      this.$store.dispatch('requestHandler',
          {
            fn: 'RestNewFollowupCallCenterServiceBatchAddFollowupPatientContactInformation',
            params: {
              nowUserId: this.userid,
              patientId: this.patientId,
              followupTaskId: this.getTaskCenterId,
              contactInformationList: _list,
            }
          }
      ).then(res => {
        if (res.retValue == 'SUCCESS') {
          this.$message.success('新增成功')
          this.$emit('refreshConcatInfo', this.patientId)
          this.phoneDialogVisible = false
        } else {
          this.errorHandle(res)
        }
      })
    },
    // 添加联系人
    addUserPhone() {
      let vm = this;
      let params = {
        // taskId: this.taskId,
        // patientId: this.patientId,
      };
      var second = vm.patientList.filter((item) => {
        if (item.relationshipName.indexOf(params.relationshipName) != -1) {
          return item
        }
      })
      if (second.length > 0) {
        params.relationshipName = params.relationshipName + (second.length + 1)
      }
      if (typeof params.patientId === "undefined") {
        this.errorHandle({message: "无法获取患者的ID"});
        return false;
      }
      return this.asyncAddUserPhone(params).then((data) => {
        if (data.status === 0) {
          // 获取用户 列表  TODO
          this.successHandle({message: "添加患者手机成功"})
          this.patientList.unshift({
            id: data.retValue,
            lastCallState: 5,
            phoneNumber: params.phoneNumber,
            contactName: params.contactName,
            relationshipName: params.relationshipName,
            lastCallTime: "",
            phoneNumberStar: params.phoneNumber.substring(0, 3) + '****' + params.phoneNumber.substring(7),
            isTodayCall: false,
          })
          // this.getNextCallNumber()
          vm.$emit('refreshConcatInfo', this.patientId)
          this.phoneDialogVisible = false;
        } else {
          this.errorHandle(data)
        }
      }).catch((err) => {
        console.log('user phoneNumber add handle --- ', err)
        this.errorHandle(err);
      })
    },
    // 取消联系人
    cancelMessageHandle() {
      let res = []
      _.each(this.patientList, (item) => {
        if (_.indexOf(this.checkPhoneList, item.id) > -1) {
          if (item.isBeenSend) {
            res.push(item.id)
          }
        }
      })
      this.checkPhoneList = [].concat(res)
      this.isModel = 'beMessage'
    },
    // 修改联系人
    updateUserPhone(updateType) {
      let vm = this;
      let data = this.currentRelationPatientInfo || {};
      let params = {
        updateType: updateType,
        id: data.id || null,
        patientId: this.patientId,
        phoneNumber: this.currentRelationPatientInfo.phoneNumber,
        relationshipName: this.currentRelationPatientInfo.relationshipName,
        contactName: this.currentRelationPatientInfo.contactName,
        lastCallState: data.lastCallState || null
      };
      var srcRel = vm.relationShipList.find((v, i) => {
        return params.relationshipName.indexOf(v.relationshipName) != -1
      })
      if (srcRel) {
        var second = vm.patientList.filter((item) => {
          if (item.relationshipName.indexOf(srcRel.relationshipName) != -1 && item.id != data.id) {
            return item
          }
        })
        if (second.length > 0) {
          params.relationshipName = srcRel.relationshipName + (second.length + 1)
        }
      }
      if (typeof params.patientId === "undefined") {
        this.errorHandle({message: "无法获取患者的ID"});
        return false;
      }

      this.asyncGetFollowupPatientContactInformation(params).then(res => {
        if (res.retValue.length > 0) {
          params.callDate = res.retValue[0].copyLastCallTime
          this.asyncUpdateUserPhone(params).then((data) => {
            if (data.status === 0) {
              // 更新用户 列表 TODO
              this.patientList.forEach((v, i) => {
                if (v.id == params.id) {
                  v.relationshipName = params.relationshipName;
                  v.lastCallState = params.lastCallState
                }
              })
              this.successHandle({message: "编辑成功"})
              vm.$emit('refreshConcatInfo', this.patientId)
              this.phoneDialogVisible = false;
            } else {
              this.errorHandle(data)
            }
          })
        }
      })
    },
    //  ============================================== 发送短信 ==================================================
    // 处理选中状态的值
    handleChangeUser() {
      console.log('handleChangeUser', arguments, this.checkPhoneList)
    },
    toggleUserMode() {
      if (this.isModel === 'beMessage') {
        this.isModel = 'messageing'
      } else {
        this.isModel = 'beMessage'
      }
    },
    sendMessageHandle(item) {
      item.isTodayCall = null
      item.lastCallTime = ""
      if (!this.smsSelect) {
        this.$message.error('请选择短信模板')
        return
      }
      this.getSmsSendRecord()
      this.messageDialogVisible = true
      this.messageTarget = item
    },
    getSmsSendRecord() {
      this.smsSendRecordLists = []
      this.$store.dispatch('requestHandler',
          {
            fn: 'RestNewFollowupCallCenterServiceGetSmsSendRecord',
            params: {
              followupTaskId: this.getTaskCenterId,
              followUpPatientId: this.patientData.followupPatientId
            }
          }
      ).then(res => {
        if (res.status == 0) {
          this.smsSendRecordLists = res.retValue
        }
      })
    },
    // 发送短信
    sendMessage() {
      console.log(this.messageTarget);

      return this.asyncSendMessage({
        phoneNumbers: [this.messageTarget]
      }).then(data => {
        if (data.status === 0) {
          // TODO
          this.$message.success('发送短信成功')
          this.messageTarget = {
            phoneNumberStar: ''
          }
          this.messageDialogVisible = false
        } else {
          this.errorHandle(data)
        }
      }).catch(err => {
        console.log('send message handle --- ', err)
        this.errorHandle(err);
      })
    },
    // 编辑联系人
    editContactClickHandler(item) {
      this.patientListItem = JSON.parse(JSON.stringify(item))
      // console.log('item--->', item);
      let phoneNumber_code = this.patientListItem.phoneNumber.split('-')
      if (phoneNumber_code.length > 1) {
        this.patientListItem.code = phoneNumber_code[0]
        this.patientListItem.phoneNumber = phoneNumber_code[1]
      }
      this.editDialogVisible = true
      if (item.relationshipName) {
        this.relationshipLevelList = [
          {value: 1, label: '一级联系人'},
          {value: 2, label: '二级联系人'},
          {value: 3, label: '三级联系人'},
        ]
      } else {
        this.relationshipLevelList = []
      }
    },
    // ========================== 获取 患者 列表 ===========================================
    getPatientList(patientList = []) {
      this.patientList = this.patientList || [];
      this.patientList.splice(0, this.patientList.length);
      if (_.isArray(patientList)) {
        _.each(patientList, (item) => {
          // 患者 数据 转换成 星号
          item.phoneNumberStar = item.phoneNumber.substring(0, 3) + '****' + item.phoneNumber.substring(7);
          if (_.indexOf(this.checkPhoneList, item.id) > -1) {
            if (!item.isBeenSend) {
              item.isBeenSend = true
            }
          }
          item.lastCallTime = item.lastCallTime.replace(/-/g, '/')
          if (new Date(item.lastCallTime).getTime() > new Date().getTime() - (3600 * 1000 * 24)) {
            item.isTodayCall = true
          }
          item.relationshipLevel = item.relationshipLevel ? item.relationshipLevel : null
          item.relationshipLevelId = item.relationshipLevelId ? item.relationshipLevelId : null
          item.showAudio = false
          item.showLoading = false
          this.patientList.push(item)
          let temp = this.patientList.filter(item => item.phoneLabel == '仅随访该号码')
          temp.length > 0 ? this.showGray = true : this.showGray = false
        });
      }
      this.getNextCallNumber();
    },
    // ============================================ 状态 =======================================
    //
    getCodeName(code) {
      var arr = ['稍后拨打', '仅随访该号码', '短信随访成功', '电话随访成功', '初始化', '挂断（接通）', '无人接听', '挂断（未接通）', '停机', '关机', '拒随', '空号', '错号', '不知情','沟通不畅']
      return arr[code - 1];
    },
    // 拨打电话 挂断时 刷新页面  ------ 刷新页面
    setCallHangUpStatusDialog() {
      this.callStatusVisible = true;
      localStorage.setItem('callStatus', false) // 稍后拨打提醒弹框的【查看】能否点击
      this.isShowNextTimeClose = false;
      // this.currentRelationPatientInfo = {
      //   id: this.currentCallNumberId,
      //   phoneNumber: this.currentCallNumber,
      //   contactName: this.currentRelationPatientInfo.contactName
      // }
      console.log(this.currentRelationPatientInfo);

    },
    //  验证时间
    beforeCallHandle(status) {
      let vm = this;
      this.$refs['nextTimeForm'].validate((valid) => {
        if (valid) {
          let params = {
            id: this.callReturnId || -1,
            userId: this.userid,
            patientId: this.patientId,
            followupPatientId: this.patientData.followupPatientId,
            followUpPatientInfoId: vm.patientData.followUpPatientInfoId,
            followupTaskId: this.getTaskCenterId,
            phoneNumber: this.currentRelationPatientInfo.phoneNumber,
            contactName: this.currentRelationPatientInfo.contactName,
            phoneNumberId: this.currentRelationPatientInfo.id,
            contactId: this.contactId,
            laterCallTime: this.nextTimeForm.nextCallTime,
            callingPhoneNumber: localStorage.getItem('callingPhoneNumber'),
            relationshipRemarks: this.patientList.find((v, i) => {
              return v.id == this.currentRelationPatientInfo.id
            }).relationshipName
          };
          this.asyncLaterCallHandle(params)
        } else {
          return false;
        }
      })

    },
    beforeCall() {
      this.hangState = true
      return new Promise(resolve => {
        let vm = this;
        this.hangupDisabled = true
        this.timer = setTimeout(() => {
          let params = {
            userId: this.userid,
            patientId: this.patientId,
            contactName: this.currentRelationPatientInfo.contactName,
            followupPatientId: this.patientData.followupPatientId,
            followUpPatientInfoId: vm.patientData.followUpPatientInfoId,
            followupTaskId: this.getTaskCenterId,
            phoneNumber: this.callingNumber.number,
            phoneNumberId: this.callingNumber.id,
            contactId: this.contactId,
            callingPhoneNumber: localStorage.getItem('callingPhoneNumber'),
          };
          if (!this.contactId) {
            this.$message.error('缺少录音id')
            resolve(false)
          } else {
            this.firstUpdatePhoneNumberCallState(this.contactId, params)
                .then(res => {
                  this.callReturnId = res.retValue
                  if (!this.hangState) { //这个状态不对直接不能打电话
                    return false
                  }
                  if (res.status == 0) {
                    this.hangupDisabled = false
                    resolve(true)
                    localStorage.setItem('callStatus', true) // 稍后拨打提醒弹框的【查看】能否点击,true表示正在通话
                  } else {
                    this.$message('接口报错联系后端')
                    this.hangupDisabled = false
                    return false
                  }
                })
          }
        }, 0)
      })
    },
    //挂断电话
    afterCallHandle(status, finshStatus) {
      let vm = this;
      if (!this.currentRelationPatientInfo || !this.currentRelationPatientInfo.id) {
        this.$message.error('缺少currentRelationPatientInfo', this.currentRelationPatientInfo)
      }
      console.log('laterCallTime--', this.currentRelationPatientInfo)

      let params = {
        id: this.callReturnId || -1,
        userId: this.userid,
        patientId: this.patientId,
        followupPatientId: this.patientData.followupPatientId,
        followUpPatientInfoId: vm.patientData.followUpPatientInfoId,
        followupTaskId: this.getTaskCenterId,
        contactName: this.currentRelationPatientInfo.contactName,
        followupSource: this.$route.query.followupSource || 1,
        // phoneNumber: this.currentRelationPatientInfo.phoneNumber,
        // phoneNumberId: this.currentRelationPatientInfo.id,
        phoneNumber: this.callingNumber.number,
        phoneNumberId: this.callingNumber.id,
        callState: status,
        contactId: this.concatIDBackUp || this.contactId || JSON.parse(localStorage.getItem('contactId')) || JSON.parse(window.sessionStorage.getItem('contactId')),
        callingPhoneNumber: localStorage.getItem('callingPhoneNumber'),
        callTime: this.seconding || 0,
        laterCallTime: this.nextTimeForm.nextCallTime,
        relationshipRemarks: this.patientList.find((v, i) => {
          return v.id == this.currentRelationPatientInfo.id
        }).relationshipName
      };
      console.log('laterCallTime--', params)
      if (!this.concatIDBackUp && !this.contactId && !JSON.parse(localStorage.getItem('contactId'))) {
        vm.$message.error("我已经默默为您服务很久了，请让我休息一下，提交之后，请退出登录")
      }
      this.asyncSetTaskStatus(params).then((data) => {
        this.nextTimeForm.nextCallTime = '';
        if (data.status === 0) {

          this.cancelNextTime();
          this.getNextCallNumber()
          // 判断状态
          var lostNumber = 0
          this.patientList.forEach((item) => {
            if (item.id == params.phoneNumberId) {
              item.lastCallState = status
              item.isTodayCall = true
            }
            if (this.isAbnormal && item.isTodayCall && (item.lastCallState == 13 || item.lastCallState == 12)) {
              lostNumber = lostNumber + 1
            }
            if (!this.isAbnormal && item.isTodayCall && item.lastCallState != 2 && item.lastCallState != 4 && item.lastCallState != 11) {
              lostNumber = lostNumber + 1
            }
          })
          if (lostNumber == this.patientList.length) {
            finshStatus = 'lostStatus'
          }
          console.log('finshStatus===============', finshStatus);
          this.$emit('getOverFollowUp', finshStatus)
          this.$emit('refreshConcatInfo', this.patientId)

          console.log('挂断挂断')
          this.callReturnId = null
          this.seconding = 0
          //
          this.callStatusVisible = false
          this.callSuccess = false;
          console.log('RE');
          this.refreshCallList()

        } else {
          this.errorHandle(data)
        }
        console.log("SUCCESS");
      }).catch((err) => {
        this.nextTimeForm.nextCallTime = '';
        console.log('Patient handle --- ', err)
        this.errorHandle(err)
      })
    },
    // 稍后拨打 --- 打开 timeDate
    callLaterHandler(status = 1) {
      this.callNextTimeVisible = true;
    },
    cancelNextTime() {
      // 取消打开的日期
      this.callNextTimeVisible = false;
    },
    async setCallTime() {
      var vm = this;
      var info = new RestNewFollowupCallCenterServiceAddRecordWaitingTime();
      info.p_id = vm.callReturnId
      info.p_contactId = vm.contactId.jobId || -1;
      var contactTime = localStorage.getItem("contactTime")
      var endTime = new Date().valueOf()
      var startTime = localStorage.getItem("startTime")
      if (contactTime) {
        info.p_waitingTime = contactTime - startTime
        info.p_talkTime = endTime - contactTime
      } else {
        info.p_waitingTime = endTime - startTime
      }
      await info.send()
      if (info.result.status == 0) {
        localStorage.removeItem("startTime")
        localStorage.removeItem("contactTime")
      }
    },
    // 操作时间 --- 过段时间再拨打
    timeTip(date) {
    },
    // ======================================= list ==================================
    // 加载新的患者数据
    loadPatientData() {
      this.$emit('saveRemark');
    },
    // 判断状态
    judgeStatus(status, isLossFollowup = false) {
      console.log(' judge status ', status, isLossFollowup, this.nextCallNumber)
      if (this.$route.query.abnormal == 2) {
        // 如果是 稍后拨打 直接跳到下一个 患者
        if (status === 1) {
          this.$notify({
            title: '提示',
            message: '本患者进入任务池，获取下一个患者信息',
            duration: 3000
          });
          this.loadPatientData();
        } else if (isLossFollowup) { // 失访
          this.$notify({
            title: '提示',
            message: '本患者已经标记为失访状态，获取下一个患者信息',
            duration: 3000
          });
          this.loadPatientData();
        } else {
          let nextCallNumber = this.nextCallNumber;
          if (nextCallNumber) {
            // 这个账号 还可以打电话
          } else {
            // 不能打电话了
            this.$notify({
              title: '提示',
              message: '该患者本次没有可以拨打的号码，患者即将进入任务池，获取下一个患者信息',
              duration: 3000
            });
            this.loadPatientData();
          }
        }
      } else {
        if (this.$route.query.abnormal == 3) {
          console.log("异常患者，需要进入下一患者了");
          this.updateNextAbnormalPatient();
        } else if (this.$route.query.abnormal == 4) {
          console.log("稍后患者，需要进入下一患者了");
          this.updateNextCallLaterPatient();
        }
      }
    },
    updateNextAbnormalPatient() {
      let params = {
        userId: this.userid,
        followupTaskId: this.getTaskCenterId,
        currentPage: 1,
        pageSize: 10
      };
      this.getAbnormalFollowupListAsync(params).then(res => {
        console.log("跳转到当前页", res.retValue);
        if (res.retValue.length > 0) {
          this.updatePage(4, res.retValue[0])
        } else {
          console.log("无患者");
          this.$router.push({
            path: "/taskDetail",
            query: {
              diseaseId: this.$route.query.diseaseId,
            }
          });
        }
      });
    },
    updateNextCallLaterPatient() {
      let params = {
        userId: this.userid,
        followupTaskId: this.getTaskCenterId,
        currentPage: 1,
        pageSize: 10
      };
      this.getCallLaterFollowupListAsync(params).then(res => {
        console.log("跳转到当前页", res.retValue);
        if (res.retValue.length > 0) {
          this.updatePage(4, res.retValue[0])
        } else {
          console.log("无患者");
          this.$router.push({
            path: "/taskDetail",
            query: {
              diseaseId: this.$route.query.diseaseId,
            }
          });
        }
      });
    },
    updatePage(num, params) {
      //num: 3异常患者处理  4稍后随访
      if (params.followupPatientId != this.$route.query.followupPatientId) {
        this.$router.push({
          path: "/callPatient",
          query: {
            abnormal: num,
            followUpPatientInfoId: params.followUpPatientInfoId,
            followupPatientId: params.followupPatientId,
            diseaseId: this.$route.query.diseaseId,
            patientId: params.patientId,
            followupSource: 1
          }
        });
      }
    },
    // 异常随访
    async getAbnormalFollowupListAsync(p) {
      let request = new RestNewFollowupCallCenterServiceGetAbnormalFollowupTaskPatientInfoList();
      request.p_userId = p.userId;
      request.p_followupTaskId = p.followupTaskId;
      request.p_pageIndex = p.currentPage;
      request.p_pageSize = p.pageSize;
      await request.send();
      return request.result;
    },
    //获取对应关系
    async getAllRelationshipLevel() {
      let result = await this.$store.dispatch('requestHandler', {
        fn: 'RestNewFollowupCallCenterServiceGetAllRelationshipLevel'
      })
      return result
    },
    // 稍后随访
    async getCallLaterFollowupListAsync(p) {
      let request = new RestNewFollowupCallCenterServiceGetCallLaterFollowupTaskPatientInfoList();
      request.p_userId = p.userId;
      request.p_followupTaskId = p.followupTaskId;
      request.p_pageIndex = p.currentPage;
      request.p_pageSize = p.pageSize;
      await request.send();
      return request.result;
    },
    //提交呼叫记录RestFeedbackOutControllerUpdateRecordList
    async updateRecordList(p) {
      let request = new RestFeedbackOutControllerUpdateRecordList()
      request.p_ids = p.ids
      await request.send()
      return request.result
    },
    async getFollowupPatientRecordList(item) {
      this.$delete(item, 'showLoading')
      this.$set(item, 'showLoading', true)
      let request = new RestNewFollowupCallCenterServiceGetPhoneRecordInfoListByPhoneNumber()
      request.p_phoneNumber = item.phoneNumber
      request.p_patientId = this.patientId
      request.p_followUpTaskId = this.getTaskCenterId
      await request.send()
      // return request.result
      if (request.result.status == 0) {
        item.phoneRecordInfoList = request.result.retValue
        this.$delete(item, 'showLoading')
        this.$set(item, 'showLoading', false)
      } else {
        this.$delete(item, 'showLoading')
        this.$set(item, 'showLoading', false)
        this.$message.error('error', res.desc)
        return false
      }
    },

    // 获取 关系列表
    getReationShip() {
      this.asyncGetReationShip().then((data) => {
        if (data.status === 0) {
          this.relationShipList = data.retValue || [];
        } else {
          this.errorHandle(data)
        }
      }).catch(err => {
        this.errorHandle(err);
      })
    },
    // 获取下一个打电话的状态
    getNextCallNumber() {
      //1稍后拨打，2仅随访该患者，3短信随访成功，4电话随访成功，5初始化，6挂断（接通），7无人接听，8挂断（未接通），9停机，10,关机 11拒随，12空号，13错号，14不知情"
      let nextCallNumber = null;
      let nextCallNumberId = null;
      if (_.isArray(this.patientList)) {
        for (let i = 0; i < this.patientList.length; i++) {
          let item = this.patientList[i];
          // 非今天打过了电话
          if (!item.isTodayCall) {
            nextCallNumber = item.phoneNumber;
            nextCallNumberId = item.id;
            break;
          }
        }
      }
      // 存储到 stroe 中
      this.setNextCallNumber({nextCallNumber, nextCallNumberId});
      return nextCallNumber;
    },
    // ======================类别相关 ===================
    getPhoneLabelList(param, index) {
      // this.$refs[`popover-`+param.id][0].doShow();
      this.customLabel = ''
      this.selectPhoneLabelId = ''
      this.asyncGetPhoneLabelList(param.id).then(res => {
        if (res.status == 0 && res.retValue == []) {
          this.radioCheck = '无标签'
          this.selectPhoneLabelId = null
          this.phoneLabelList = []
          this.selectPhoneLabelId = ''
        } else {
          let tt = res.retValue.find(it => it.label != '无标签' && it.label != '仅随访该号码')
          tt ? this.customLabel = tt.label : this.customLabel == ''
          this.radioCheck = param.phoneLabel
          this.phoneLabelList = res.retValue
        }
      })
    },
    inputFocus(param) {
      if (this.phoneLabelList.length > 0) {
        let temp = this.phoneLabelList.find(item => item.label == this.customLabel)
        temp ? this.selectPhoneLabelId = temp.id : ''
      }
    },
    categoryCheckChange(e, param, isChoose) {
      this.radioCheck = e;
      let temp = this.phoneLabelList.filter(item => item.label == e)
      if (temp.length > 0 && (e || e == '无标签' || e == '仅随访该号码')) {
        // 无标签。仅随访
        this.selectPhoneLabelId = temp[0].id
      } else if (!this.selectPhoneLabelId) {
        this.selectPhoneLabelId = ''
      }
      let data = {
        id: this.selectPhoneLabelId,
        patientId: this.patientId,
        taskId: this.getTaskCenterId,
        phoneId: param.id,
        label: isChoose ? e : this.customLabel,
        isChoose: isChoose
      }
      this.asyncAddOrSelectPhoneLabel(data).then(res => {
        if (res.status == 0) {
          // this.$refs[`popover-`+param.id][0].doClose();
          // this.$refs[`popover-`+param.id][0].doClose()
          document.body.click()
          this.refreshCallList()
        }
      })
    },
    refreshCallList() {
      console.log('refresh')
      this.removeContactId();
      this.concatIDBackUp = ""
      localStorage.removeItem('concatID')
      this.asyncGetFollowupPatientContactInformation({patientId: this.patientId}).then(res => {
        this.patientList = res.retValue.map(item => {
          item.phoneNumberStar = item.phoneNumber.substring(0, 3) + '****' + item.phoneNumber.substring(7)
          item.relationshipLevel = item.relationshipLevel == 0 ? null : item.relationshipLevel
          // item.showLoading = false
          return item
        })
        //
        let temp = this.patientList.filter(item => item.phoneLabel == '仅随访该号码')
        temp.length > 0 ? this.showGray = true : this.showGray = false
      })

      this.$forceUpdate()
    },
    closePop(param) {
      document.body.click()
    },
    afterCallConfirm() {
      this.afterCallHandle(1)
    },
    async asyncGetPhoneLabelList(phoneid) {
      let request = new RestNewFollowupCallCenterServiceGetPhoneLabelList()
      request.p_phoneId = phoneid
      await request.send()
      return request.result
    },
    async asyncAddOrSelectPhoneLabel(p) {
      let request = new RestNewFollowupCallCenterServiceAddOrSelectPhoneLabel()
      request.p_id = p.id
      request.p_patientId = p.patientId
      request.p_taskId = p.taskId
      request.p_phoneId = p.phoneId
      request.p_label = p.label
      request.p_isChoose = p.isChoose
      await request.send()
      return request.result
    },
    //  ======================  async  ==========================================
    //获取短信列表
    async asyncGetSmsList(p) {
      let request = new RestNewFollowupCallCenterServiceGetSmsTemplateTaskList()
      request.p_followUpTaskId = this.getTaskCenterId
      await request.send()
      return request.result
    },
    async asyncLaterCallHandle(params) {
      let vm = this;
      let info = new RestNewFollowupCallCenterServiceUpdateLaterCallFollowupTask();
      for (var keys in params) {
        info['p_' + keys] = params[keys]
      }
      await info.send()
      if (info.result.status == 0) {
        vm.judgeStatus(1)
        vm.callStatusVisible = false;
        vm.cancelNextTime()
        this.seconding = 0
        this.callReturnId = null
      } else {
        vm.$message.error("稍后拨打错误：" + info.result.desc)
      }
    },
    /**
     * 添加联系人接口
     * @param params={patientId,phoneNumber,relation}
     * @return id 添加题目的id
     */
    async asyncAddUserPhone(params) {
      let data = new RestNewFollowupCallCenterServiceAddFollowupPatientContactInformation();
      data.p_patientId = this.patientId;
      data.p_nowUserId = sessionStorage.getItem('userid')
      data.p_phoneNumber = params.phoneNumber;
      data.p_relationshipName = params.relationshipName;
      data.p_contactName = params.contactName
      data.p_followupTaskId = this.getTaskCenterId
      data.p_phoneType = params.phoneType
      data.p_relationshipLevelId = params.relationshipLevelId
      data.p_cooperateScore = params.cooperateScore
      console.log(data);
      await data.send();
      return data.result
    },
    // 获取患者联系方式
    async asyncGetFollowupPatientContactInformation(params) {
      let data = new RestNewFollowupCallCenterServiceGetFollowupPatientContactInformationList();
      data.p_patientId = params.patientId
      data.p_followupTaskId = this.getTaskCenterId
      await data.send();
      return data.result;
    },
    // 修改联系人
    async asyncUpdateUserPhone(params) {
      let data = new RestNewFollowupCallCenterServiceUpdateFollowupPatientContactInformation();
      data.p_id = params.id;
      data.p_patientId = this.patientId
      data.p_contactName = params.contactName
      data.p_phoneNumber = params.phoneNumber;
      data.p_nowUserId = sessionStorage.getItem('userid')
      data.p_relationshipName = params.relationshipName;
      data.p_lastCallState = params.lastCallState;
      data.p_updateType = params.updateType
      data.p_taskId = this.getTaskCenterId
      data.p_callDate = params.callDate
      await data.send();
      return data.result;
    },
    // 失效随访  或者 暂时添加状态
    async asyncSetTaskStatus(params) {
      let data = new RestNewFollowupCallCenterServiceUpdatePhoneNumberCallState();
      for (var keys in params) {
        data['p_' + keys] = params[keys]
        data.p_nowUserId = sessionStorage.getItem('userid')
      }
      await data.send();
      console.log('result', data.result);
      return data.result;
    },
    //第一次保存呼叫记录
    async firstUpdatePhoneNumberCallState(contactId, p) {
      let request = new RestNewFollowupCallCenterServiceFirstUpdatePhoneNumberCallState()
      request.p_contactId = contactId
      request.p_userId = p.userId
      request.p_nowUserId = sessionStorage.getItem('userid')
      request.p_patientId = p.patientId
      request.p_followupPatientId = p.followupPatientId
      request.p_followupTaskId = p.followupTaskId
      request.p_taskId = p.followupTaskId
      request.p_followUpPatientInfoId = p.followUpPatientInfoId
      request.p_phoneNumberId = p.phoneNumberId
      request.p_phoneNumber = p.phoneNumber
      request.p_callingPhoneNumber = p.callingPhoneNumber
      await request.send()
      return request.result
    },
    // 获取 关系列表
    async asyncGetReationShip() {
      let data = new RestCallCenterServiceGetAllRelationship();
      await data.send();
      return data.result;
    },
    // 发送短信
    async asyncSendMessage(params) {
      let data = new RestNewFollowupCallCenterServiceSendingFollowupSmsTask();
      data.p_phoneNumberList = params.phoneNumbers || []
      data.p_userId = this.userid
      data.p_followupPatientId = this.patientData.followupPatientId;
      data.p_followUpTaskId = this.getTaskCenterId
      data.p_smsCode = this.smsSelect
      await data.send();
      return data.result;
    },
    async getSMSDtail(code) {
      let request = new RestNewFollowupCallCenterServiceGetSmsTemplateByCode()
      request.p_smsCode = code
      await request.send()
      // return request.result
      this.smsDetail = request.result.retValue.smsContent
    },

    /**
     * 手动拨号
     * @param callNumber
     * @param id
     */
    manualCall(callNumber, id, it) {
      this.hangupDisabled = true
      console.log(it);
      this.currentRelationPatientInfo = it;
      if (this.$route.query.aliLogin) {
        this.$message.error('当前状态不能拨打电话')
        return false
      }
      if (window.workbench.getStatusCode().code == 1 || window.workbench.getStatusCode().code == 0) {
        this.$alert('请点击下方重新登录阿里云按钮重新登录账号，并等待看到提示“可拨号”后才能进行后续拨打电话操作', '状态异常', {
          confirmButtonText: '重新登录阿里云',
          callback: action => {
            window.workbench.logIn()
          }
        });
        return false
      }
      this.checkSubmitStatus(callNumber)
          .then(res => {
            if (res) {
              if (this.isCalling) {
                return
              }
              console.log(11111);
              this.setNextCallNumber({nextCallNumber: callNumber, nextCallNumberId: id});
              this.callingNumber = {
                number: callNumber,
                id: id
              }
              this.isCalling = true
              console.log(window.workbench);
              console.log("电话前状态=====》", window.workbench.getStatusCode());
              if (window.workbench.getStatusCode().code == -1) {
                console.log('未注册');
              }
              window.workbench.call(callNumber, this.calleePhoneNumber, null, false);
              this.setCurrentCallNumber({currentCallNumber: callNumber, currentCallNumberId: id})
              this.setCurrentCalling(true)
              // this.beforeCall()
              //     .then((res) => {
              //       if (res) {
              //         // this.getFollowupPatientRecordList(it)
              //         this.setCallingStatus()
              //         window.pubsub && window.pubsub.emit('calling');
              //       } else {
              //         this.$message.error('缺少contractId')
              //       }
              //     })
            } else {
              return
            }
          })
      // this.$emit('manualCall')

    },
    manualCallBack(callNumber) {
      this.answerType = 2
      let id = this.patientList.find(item => item.phoneNumber == callNumber).id
      console.log(callNumber, this.patientList.find(item => item.phoneNumber == callNumber), id)
      this.setNextCallNumber({nextCallNumber: callNumber, nextCallNumberId: id});
      this.isCalling = true
      setTimeout(() => {
        this.setCurrentCallNumber({currentCallNumber: callNumber, currentCallNumberId: id})
        this.setCurrentCalling(true)
        this.$emit('manualCall')
      }, 1000)
    },

    confirmEditHandler(info, type) {
      console.log('info', info);
      if (type == 'update') { //编辑弹框
        info.phoneNumber = info.code ? `${info.code}-${info.phoneNumber}` : info.phoneNumber
      }
      // return 
      let params = {
        updateType: 1,
        id: info.id || null,
        patientId: this.patientId,
        phoneNumber: info.phoneNumber,
        relationshipName: info.relationshipName,
        contactName: info.contactName,
        phoneType: info.phoneType,
        relationshipLevelId: info.relationshipLevelId,
        relationshipLevel: info.relationshipLevel,
        cooperateScore: info.cooperateScore,
        lastCallState: info.lastCallState || null
      };
      this.asyncGetFollowupPatientContactInformation(params).then(res => {
        if (res.retValue.length > 0) {
          params.callDate = res.retValue[0].copyLastCallTime
          this.updateContactInfoAsync(params, true).then((data) => {
            if (data.status == 0) {
              // 更新用户 列表 TODO
              // this.patientList.forEach((v, i) => {
              //   if (v.id == params.id) {
              //     v.relationshipName = params.relationshipName;
              //     v.cooperateScore = params.cooperateScore
              //     v.contactName = params.contactName
              //     v.relationshipName = params.relationshipName
              //     v.lastCallState = params.lastCallState
              //   }
              // })
              this.successHandle({message: "编辑成功"})
              this.$emit('refreshConcatInfo', this.patientId)
              this.editDialogVisible = false;
            } else {
              this.errorHandle(data)
            }
          })
        }
      })

    },
    async updateContactInfoAsync(p, b) {
      let result = await this.$store.dispatch('requestHandler', {
        fn: 'RestNewFollowupCallCenterServiceUpdateFollowupPatientContactInformation',
        params: {
          nowUserId: sessionStorage.getItem('userid'),
          id: p.id,
          patientId: p.patientId,
          phoneNumber: p.phoneNumber,
          relationshipName: p.relationshipName,
          lastCallState: p.lastCallState,
          taskId: this.getTaskCenterId,
          callDate: p.callDate,
          updateType: 1,
          contactName: p.contactName,
          phoneType: p.phoneType,
          // relationshipLevelId: p.relationshipLevelId,
          relationshipLevel: p.relationshipLevel,
          cooperateScore: p.cooperateScore,
          isIdentifyBelongAddress: b,
        }
      })
      return result
    },
  }
}
</script>
<style lang="scss">
*::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 5px; /*高宽分别对应横竖滚动条的尺寸*/
  height: 1px;
}

*::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 10px;
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: #61aafa;
}

*::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  border-radius: 10px;
  background: #ededed;
}

.call-status-btn-wrapper {
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  .phone-item {
    margin-top: 20px;

    & > span {
      display: inline-block;
      min-width: 90px;
      text-align: right;
    }
  }
}

.sms-record-dialog {
  .el-dialog__body {
    max-height: 500px;
    overflow: auto;
  }
}

.sms-record-table.el-table--fit {
  border-right: 1px solid #ebeef5;
}

.sms-record-table {
  width: 100%;
  border: 1px solid #ebeef5;
  border-bottom: none;
  color: rgb(145, 149, 156);

  th.el-table__cell > .cell {
    font-weight: bold;
    color: rgb(145, 149, 156);
  }

  td.el-table__cell, .el-table th.el-table__cell.is-leaf {
    color: rgb(145, 149, 156);
  }

  .el-icon-success {
    cursor: auto;
  }
}

</style>
<style scoped lang="scss">
* {
  box-sizing: border-box;
}

.bd {
  border: 1px solid transparent;
}

.error {
  border: 1px solid red;
}

@keyframes dot {
  0% {
    width: 0em;
    margin-right: 1.5em;
  }
  33% {
    width: 0.5em;
    margin-right: 1em;
  }
  66% {
    width: 0.8em;
    margin-right: 1.1em;
  }
  100% {
    width: 1.5em;
    margin-right: 0em;
  }
}

.audio-container {
  position: relative;
  padding: 15px;

  .close {
    cursor: pointer;
    position: absolute;
    right: 0;
    top: 0;
    font-weight: 700;
  }
}

.page-container {
  width: 100%;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.08), 0px 1px 4px 0px rgba(0, 0, 0, 0.16);
  border-radius: 8px;
  /*margin-top: 20px;*/
  display: flex;
  flex-direction: column;
  box-sizing: border-box;

  & > .header {
    padding: 12.5px 10px 12.5px 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid rgba(216, 216, 216, 1);
    width: 100%;

    & > span {
      display: inline-block;
      color: #000000;
      font-weight: 600;
      font-size: 16px;
    }

    .el-button {
      padding: 5px 10px;
      font-size: 15px;
      font-weight: 600;

      &:before {
        margin-right: 5px;
      }
    }
  }

  .call-item {
    .btn {
      margin-left: 15px;
    }

    .hang-up {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;

      .callStatus {
        margin: 0 15px;

        &.calling {
          color: #248cfa;
        }

        &.connect {
          color: #0b8235;
        }
      }
    }
  }

  & > .user-list {
    max-height: calc(100vh - 60px - 60px - 329px);
    min-height: 300px;
    overflow: auto;

    .lastCall {
      .user_tel_box {
        background-color: rgba(245, 222, 179, 1);
      }
    }

    .phoneList {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: flex-start;
      width: 100%;
      line-height: 28px;
      padding: 10px;
      border-bottom: 1px solid #ccc;

      .audio-list {
        width: 100%;
        text-align: left;

        .audio-list-item {
          padding-right: 20px;
          display: flex;
          align-items: center;
          justify-content: space-between;

          span, div {
            color: #666;
            font-size: 12px;
          }
        }
      }

      .user_tel_box {
        &:hover, &:active {
          background: rgba(245, 222, 179, 0.4);
        }
      }

      & > div:nth-of-type(1) {
        cursor: pointer;
        width: 100%;
        text-align: left;
        display: flex;
      //FollowupTaskPatientInfo FollowupTaskPatientInfo
      }

      .user_tel_base {
        width: 100%;
        display: flex;
        align-items: center;
        .min15 {
          width: 160px;
        }
        span {
          margin-right: 10px;
          font-size: 14px;
          display: inline-block;

        }

        .tel_relation {
          font-size: 14px;
          width: 20%;
          min-width: 57px;
          text-align: left;
        }

        .phone-number {
          font-size: 14px;
        }

        .category {
          &-radio-group {
            display: flex;
            flex-direction: column;
          }

          &-item {
            display: flex;

            &-text {
              width: 60%;
              line-height: 28px;
            }
          }
        }

      }

      .user-tel-state {
        width: 30%;
        min-width: 90px;
        line-height: 28px;
        display: flex;
        justify-content: flex-end;

        .icon-span {
          display: inline-block;
          width: 15%;
          margin: 0 10px;
          display: flex;
          align-items: center;

          img {
            width: 100%;
          }
        }

        .el-icon-edit-outline, .el-icon-phone, .el-icon-service, .el-icon-microphone {
          width: 30px;
          height: 30px;

          &:before {
            font-size: 22px;
          }
        }

        .el-icon-phone, .el-icon-service {
          margin-left: 8px;

          &:before {
            font-size: 22px;
            color: #248cfa;
          }
        }

        .calling-color {
          margin-right: 10px;
        }
      }

    }

    .message-list {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      margin-bottom: 20px;

      & > .el-checkbox {
        margin-top: 10px;
        margin-left: 20px;
        font-size: 16px;

      }
    }
  }

  .phone_edit_span {
    font-size: 16px;
    margin: 0 5px;
    padding: 5px;
  }

  .phone_edit_span:hover {
    cursor: pointer;
  }

  .contact_info_item {
    display: flex;
    align-items: center;
    margin-bottom: 10px;

    & > div {
      margin-right: 8px;
    }
  }

  .phone-button {
    width: 280px;
    display: flex;
    justify-content: space-between;
    margin-right: 15px;

    .icon-addConnect {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-left: 10px;
      cursor: pointer;

      i {
        /*width: 33%;*/
        img {
          width: 100%;
        }
      }

      span {
        font-size: 12px;
        color: #248cfa;
      }
    }

    .select-message {
      width: 150px;
      display: flex;
      align-items: center;

      .el-select {
        width: 100% !important;
      }
    }

    .el-icon-circle-plus-outline, .el-icon-s-promotion {
      &:before {
        font-size: 18px;
      }
    }
  }
}
</style>
<style lang="scss">
.category {
  &-radio-group {
    .category-item {
      display: grid;
      grid-template-columns: 30px 150px 30px;
      grid-column-gap: 10px;

      &-text {
        line-height: 28px;
      }
    }

    .el-radio {
      margin-right: 8px;
      margin-bottom: 10px;
      width: 99%;

      .el-radio__label {
        width: 100%;
        padding: 0;
      }
    }

    .el-radio__input {
      display: none;
    }

    .el-radio__label {
      padding: 0 15px;
      width: 100%;
    }

    .el-radio__input.is-checked + .el-radio__label {
      color: #000;
    }
  }
}

.user-phoneNumber {
  .el-popover__reference {
    span {
      z-index: 999;
    }

    span:hover {
      border: 1px solid #248cfa !important;
      border-radius: 4px;
    }
  }
}

.dialog-item {
  display: flex;
  margin-bottom: 15px;
}
</style>
<style lang="scss">
// .edit-dialog {
//   .el-input {
//     width: 150px !important;
//     margin-right: 15px;

//   }
// }
</style>